<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kB45T2/tc-custom/9780795352683.jpg?1704315954223" alt="This image is the cover for the book Annals of a Quiet Neighborhood, The Cullen Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Annals of a Quiet Neighborhood, The Cullen Collection
      </h1>
      <p class="bookDescription body article font2">
        <b>The story of a young minister and his flock—first in the Scottish author’s Marshmallows Trilogy including <i>The Seaboard Parish</i> and <i>The Vicar’s Daughter</i>.  </b><br/>  <br/> MacDonald’s first major English novel, published in 1867, was set in the village of Arundel on the downs south of London near the south channel coast. It was the site of MacDonald’s first and only pastorate as a newly married minister in 1851-53. This book is wonderfully descriptive of the region, with autobiographical hints of MacDonald’s outlook as a young pastor. Chronicling the daily life of one of MacDonald’s fictionalized “ideal ministers”—perhaps a portrayal of the shepherd-pastor MacDonald had himself hoped to be—the <i>Annals</i> proved one of his most popular novels.<br/>  <br/> First released in the <i>Sunday Magazine,</i> which was intended for “Sabbath reading,” <i>Annals of a Quiet Neighbourhood</i> was quickly published in numerous book editions and contributed in a significant way to MacDonald’s growing popularity in America. Though less spine-riveting of plot, the three volumes of the Marshmallows Trilogy spawned by <i>Annals</i> provide some of MacDonald’s most homiletic and deeply spiritual writings.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George MacDonald, Michael Phillips
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58ad8d66